<template>
  <div style="background: #fff;">
    <learnCardBind :value.sync="showLearnCardBind"></learnCardBind>
    <div class="new_content">
      <div class="new_project_detail">
        <div class="npd_info">
          <div class="npdi_pic"><img :src="projInfo.iamge" /></div>
          <div class="npdi_txt">
            <div class="npdit1">{{projInfo.projectName}}</div>
            <div class="npdit2">项目负责人：{{projInfo.nickName}}　　　　单位：{{projInfo.companyId}}</div>
            <div class="npdit2">项目类别：{{projInfo.projectCategoryName}}　　　　学分类别：{{projInfo.creditCateggoryName}}　　　　学分：{{projInfo.creditSetting}} 分</div>
            <template v-if="projInfo.projectDescription">
              <div class="npdit3" v-if="showFullProjectDescription">
                <div class="npdit_title">项目描述：</div>
                <div class="npdit_main"><span>{{projInfo.projectDescription.length>=42?projInfo.projectDescription.substring(0,42) + '...':projInfo.projectDescription}}</span><a href="javascript:;" v-if="projInfo.projectDescription.length>=42" @click="showFullDescription" >展开</a></div>
              </div>
              <div class="npdit4" v-if="!showFullProjectDescription">
                <div class="npdit_title">项目描述：</div>
                <div class="npdit_main"><span>{{projInfo.projectDescription}}</span><a href="javascript:;" @click="hiddenFullDescription">收起</a></div>
              </div>
            </template>
            <template v-if="projInfo.projectTarget">
              <div class="npdit3" v-if="showFullProjectTarget">
                <div class="npdit_title">项目目标：</div>
                <div class="npdit_main"><span>{{projInfo.projectTarget.length>=42?projInfo.projectTarget.substring(0,42) + '...':projInfo.projectTarget}}</span><a href="javascript:;" v-if="projInfo.projectTarget.length>=42" @click="showFullTarget">展开</a></div>
              </div>
              <div class="npdit4" v-if="!showFullProjectTarget">
                <div class="npdit_title">项目目标：</div>
                <div class="npdit_main"><span>{{projInfo.projectTarget}}</span><a href="javascript:;" @click="hiddenFullTarget">收起</a></div>
              </div>
            </template>
            <div class="npdit2">
              <a href="javascript:;" class="npdit2_added" v-if="projInfo.projState == 4" disabled="disabled" style="color: #fff;">已授予学分</a>
              <a href="javascript:;" style="color: #fff;" class="npdit2_sqxf" v-else-if="projInfo.projState == 2" @click="applyScore(projInfo.creditCateggory,projInfo.creditSetting)"  v-show="applyScoreShow">申请学分</a>
              <a href="javascript:;" style="color: #fff;" class="npdit2_sqxf" v-else-if="projInfo.projState == 3" @click="cancelApplyScore()">取消申请学分</a>
              <a href="javascript:;" style="color: #fff;" class="npdit2_sqxf_not" v-else title="未完成学习不能申请学分">申请学分</a>
              <a href="javascript:;" style="color: #fff;" class="npdit2_added" v-if="projInfo.isOwn == 1">已添加到我的项目</a>
              <a href="javascript:;" style="color: #fff;" class="npdit2_add" v-else @click="addToMyProject()" id="addMy">+ 添加到我的项目</a>
            </div>
          </div>
        </div>
        <div class="nupmrm_content" style="min-height: 300px;">
          <table class="collapse ba br2 b--black-10 pv1 ph1" style="text-align: center;width:100%; ">
            <tbody>
            <tr class="striped--near-white" style="height: 33px">
              <th class="pv1 ph3 tl f6 fw6 ttu" style="text-align: center" width="10%">序号</th>
              <th class="f6 ttu fw6 pv1 ph1" width="40%">课程名称</th>
              <th class="f6 ttu fw6 pv1 ph1" width="10%">主讲人</th>
              <th class="f6 ttu fw6 pv1 ph1" width="10%">课程状态</th>
              <th class="f6 ttu fw6 pv1 ph0" colspan="30%" width="">操作</th>
            </tr>
            <tr class="striped--near-white" v-for="(item, index) in courseList">
              <td class="pv1 ph0" style="text-align: center">{{index+1}}</td>
              <td class="pv1 ph1" style="text-align: left;">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                  <a href="javascript:;"
                     @click="openVideoware(item.id)"
                     class="course_name overflow"
                     :title="item.name">{{item.name}}</a>
                </el-tooltip>
              </td>
              <td class="pv1 ph1">{{item.nickName}}</td>
              <td class="pv1 ph1">
                <div  :class="getStateColor(item.courseState)">
                 {{courseStateComputed(item.courseState)}}
                </div>
              </td>
              <td class="pv1 ph0">
                <a href="javascript:;"
                   @click="openVideoware(item.id)"
                   class="k1" style="padding-right: 0px;">视频</a>
              </td>
              <td class="pv1 ph0" width="10%">
                <a
                    v-if="
                      trainingInfo.practiseSwitch === 0 || item.practiceNull
                    "
                    class="k3-3"
                    href="javascript:"
                    style="padding-right: 0"
                    >考试[无]</a
                  >
                <a  v-else href='javascript:;' style="padding-right: 0px;"  @click='haveBandedLearningCard($route.query.trainingId,$route.query.projectId,item.id,item.courseFieldID,$route.query.setTop,item.name)' class='k3'>
                  考试[{{typeof item.practiseScore != 'undefined' && item.practiseScore != null  ? "最高"+item.practiseScore+"分":"未考"}}]
                </a>
              </td>
              <td class="pv1 ph0">
                <a href="javascript:;" style="padding-right: 0px;"  v-if="item.handoutNull"  class="k2-2">讲义[无]</a>
                <a href="javascript:;" style="padding-right: 0px;"  v-else  @click="openCourseware($route.query.trainingId,$route.query.projectId,item.id)" class="k2">讲义</a>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {getProjectDetail,getProjectCourse,addMyProject,calcelApplyCredit,applyCredit,getTrainingById,getUserCoursePercent} from '../api/api';
  import learnCardBind from '../components/LearnCardBind'
  export default {
    components: {
      learnCardBind
    },
    props: {
      trainingId: {
        type: Number,
        required: true
      },
      projectId: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        projInfo:{
        },
        applyScoreShow:true,
        courseList:null,
        showFullProjectDescription:true,
        showFullProjectTarget:true,
        showLearnCardBind: false,
        readOnly:false,
        creditBingdingTerm:3,
        trainingInfo: {}
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ]),
    },
    mounted () {
      getProjectDetail({
        trainingId: this.trainingId,
        projectId: this.projectId,
      }).then((response) => {
        this.projInfo = response.data.data.data
      });

      getProjectCourse({
        trainingId: this.trainingId,
        projectId: this.projectId,
      }).then((response) => {
        this.courseList = response.data.data.data
      });

      var param = {id: this.trainingId,userId:this.userInfo.id};
      getTrainingById(param).then((res) => {
          this.trainingInfo=res.data.data.training;
          this.creditBingdingTerm=res.data.data.training.creditBingdingTerm;
        if(!(this.$moment()).isBefore(this.$moment(res.data.data.training.endTime))){
          this.readOnly = true;
        }else{
          this.readOnly = false;
        }
      });

    },
    created () {
    },
    methods: {
      openCourseware(tId,pId,cId){
        if(!this.readOnly){
            window.open("/handout"
              + "?uId=" + this.userInfo.id
              + "&tId=" + tId
              + "&pId=" + pId
              + "&cId=" + cId, 'handout_blank');
        }else {
          this.$message({
            type: 'info',
            message: '该培训已结束！'
          });
        }
      },
      courseStateComputed: function (ybsCourseState) {
        let courseState = "未学习"
        if(ybsCourseState){
          switch(ybsCourseState)
          {
            case 1:
              courseState="学习中"
              break;
            case 2:
              courseState="已学完"
              break;
          }
        }
        return courseState;
      },
     getStateColor(state){
      switch(state) {
      case 1: return 'state-learning';
      case 2: return 'state-complete';
      default: return 'state-uncomplete';
     }
    },
      openVideoware(cId ){
        if(!this.readOnly){
            window.open("/videoPlayer"
              +"?uId="+this.userInfo.id
              +"&tId="+this.trainingId
              +"&pId="+this.projectId
              +"&setTop="+ this.$route.query.setTop
              +"&cId="+cId, 'video_blank');
        }else{
          this.$message({
            type: 'info',
            message: '该培训已结束！'
          });
        }
      },
      addToMyProject(){
        if(this.readOnly == true){
          this.$message({
            type: 'info',
            message: '该培训已结束！'
          });
        }else{
          addMyProject({
            trainingId: this.trainingId,
            projectId: this.projectId,
          }).then((response) => {
            if (response.status == 200) {
              this.projInfo.isOwn=1;
            } else {

            }
          });
        }
      },
      showFullDescription(){
        this.showFullProjectDescription=false;
      },
      hiddenFullDescription(){
        this.showFullProjectDescription=true;
      },
      showFullTarget(){
        this.showFullProjectTarget=false;
      },
      hiddenFullTarget(){
        this.showFullProjectTarget=true;
      },
      applyScore(creditCateggory,creditSetting){
        if(this.readOnly == true){
          this.$message({
            type: 'info',
            message: '该培训已结束！'
          });
        }else{
          if(!creditCateggory ||creditCateggory==''|| creditCateggory==null || creditCateggory=='0' ||
            !creditSetting ||creditSetting==''|| creditSetting==null || creditSetting=='0'){
            this.$alert('该项目在您所在地区尚未开展，您暂不能申请学分！', '提示', {
              confirmButtonText: '确定',
            });
          }else{
            this.$confirm('是否确定申请此项目学分?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.applyScoreShow=false;
              applyCredit({
                trainingId: this.trainingId,
                projectId: this.projectId,
                userId:this.userInfo.id
              }).then((response) => {
                this.applyScoreShow=true;
                if(response.data.status==1){
                  this.$alert(response.data.info, '提示', {
                    confirmButtonText: '确定',
                    type:'success',
                    callback: action => {
                      this.projInfo.projState=3;

                    }
                  });
                }else{
                  if(response.data.info=='人员信息在本省学分管理平台不存在，请下载继教通APP进行注册'
                    || response.data.info=='人员信息与本省学分管理平台不一致，请核实修改'){
                    this.$alert('<div style="text-align:center;font-size:13px;">' +
                      '<p style="padding-bottom:25px;">'+response.data.info+'</p>' +
                      '<img src="https://source.yiboshi.com/public/img/%E7%BB%A7%E6%95%99%E9%80%9AAPP%E4%B8%8B%E8%BD%BD.gif">' +
                      '<p style="color:#9a9a9a;font-size:12px;">手机扫一扫下载继教通客户端</p>', '提示', {
                      dangerouslyUseHTMLString: true,
                    });
                  }else{
                    this.$alert(response.data.info, '提示', {
                      confirmButtonText: '确定',
                      type:'error',
                      callback: action => {
                      }
                    });
                  }
                }
              });
            }).catch(() => {
              /*this.$message({
               type: 'warning',
               message: '申请失败'
               });*/
            });
          }
        }
      },
      cancelApplyScore(){
        if(this.readOnly == true){
          this.$message({
            type: 'info',
            message: '该培训已结束！'
          });
        }else{
          this.$confirm('确认要取消申请学分吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            calcelApplyCredit({
              trainingId: this.trainingId,
              projectId: this.projectId,
              userId: this.userInfo.id
            }).then((response) => {
              if(response.data.status==1){
                this.$alert(response.data.info, '提示', {
                  confirmButtonText: '确定',
                  type:'success'
                });
                this.projInfo.projState=2;
              }else{
                this.$alert(response.data.info, '提示', {
                  confirmButtonText: '确定',
                  type:'error'
                });
              }
            });
          }).catch(() => {
            /*this.$message({
             type: 'warning',
             message: '取消申请失败'
             });*/
          });
        }
      },
      haveBandedLearningCard(trainingId,projectId,courseId,courseFieldID,setTop,courseName){
        if(this.readOnly == true){
          this.$message({
            type: 'info',
            message: '该培训已结束！'
          });
        }else {
          /*if(this.creditBingdingTerm==1){
            if(this.currentTraining.isBandLearningCard){
              window.open("/usercenter/practice?courseId="+ courseId
                + "&courseFieldID="+ courseFieldID
                + "&trainingId="+ trainingId
                + "&projectId="+ projectId
                + "&courseName=" + courseName, 'practice_blank');
            }else {
              this.showLearnCardBind = true;
            }
          }else{*/
          getUserCoursePercent(this.userInfo.id,{//获得课程视频观看完成度
            trainingId: trainingId,
            projectId: projectId,
            courseId: courseId
          }).then((response) => {
            if(response.data.percent >= this.trainingInfo.electiveRatio){
              window.open("/usercenter/practice?courseId="+ courseId
                + "&courseFieldID="+ courseFieldID
                + "&trainingId="+ trainingId
                + "&projectId="+ projectId
                + "&setTop="+ setTop
                + "&courseName=" + courseName, 'practice_blank');
            }else{
              this.$alert("视频达到观看要求后方可进行考试", '提示', {
                confirmButtonText: '确定',
                type:'warning',
                callback: action => {

                }
              });
            }
          });
        }
      },

    }
  }
</script>

<style scoped>
  .overflow{
    overflow:hidden;          /*超出部分隐藏*/
    white-space:nowrap;
    max-width: 395px;
    /*文本溢出用"..."表示*/
    text-overflow:ellipsis;                    /*适用IE*/
    -o-text-overflow:ellipsis;                 /*适用opera*/
  }
  table.collapse tr td{padding: 15px 0px;}

.state-complete, .state-learning, .state-uncomplete {
  color: #ffffff;
  width: 74px;
  height: 23px;
  margin: 0 auto;
  border-radius: 4px;
  line-height: 23px;
  }

.state-complete {
    background-color: #00BE94;
  }

.state-learning {
  background-color: #FF5300; 
  }

.state-uncomplete {
  background-color: #999999;
  }

 a.k3-3 {
    color: #999888;
    cursor: default;
}  
</style>



// WEBPACK FOOTER //
// src/components/ProjectInfo.vue